import { Link, useParams } from "react-router-dom";
import InfoIcon from "./InfoIcon";
import { faHouseLaptop } from "@fortawesome/free-solid-svg-icons";

export default function Error(){
    const {message}=useParams()

    return <div>
        <h1>{message}</h1>
        <Link to='/' className="btn btn-secondary bgnt" ><InfoIcon icon={faHouseLaptop} size='xl' />Dashboard</Link>
    </div>

}